import { z } from "zod";

import { hoursToMilliseconds, minutesToMilliseconds, secondsToMilliseconds } from "~/tools/date-time";
import type { Record } from "~/tools/record";

const schema = z.enum([
	"off",
	// use short interval for dev to make testing faster
	import.meta.env.DEV ? "5s_dev_only" : "15s",
	"30s",
	"1m",
	"5m",
	"15m",
	"30m",
	"1h",
	"2h",
	"1d",
]);

export const REFRESH_INTERVALS = schema.options;

export type RefreshInterval = z.infer<typeof schema>;

export function toRefreshInterval(input: undefined | null | string): undefined | RefreshInterval {
	const { data } = schema.safeParse(input);

	return data;
}

const REFRESH_INTERVAL_TO_MS = {
	off: undefined,
	"5s_dev_only": secondsToMilliseconds(5),
	"15s": secondsToMilliseconds(15),
	"30s": secondsToMilliseconds(30),
	"1m": minutesToMilliseconds(1),
	"5m": minutesToMilliseconds(5),
	"15m": minutesToMilliseconds(15),
	"30m": minutesToMilliseconds(30),
	"1h": hoursToMilliseconds(1),
	"2h": hoursToMilliseconds(2),
	"1d": hoursToMilliseconds(24),
} satisfies Record<RefreshInterval>;

export function refreshIntervalToMs(interval: RefreshInterval): undefined | number {
	return REFRESH_INTERVAL_TO_MS[interval];
}
